<template>
  <div class="redirecting-message-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">

        <weex-text v-if="!redirectionCountdownCompleted" class="margin-top-10 text-align-center">
          <span class="font-size-sm text-color-black">{{redirectingOnPartnerPageMessage}}</span>
          <span class="font-size-sm text-color-blue">{{redirectionCountdownRemainingSeconds}} second(s).</span>
        </weex-text>

        <weex-text v-if="redirectionCountdownCompleted" class="margin-top-10 text-align-center">
          <span @click="redirectToPartnerPage" class="item-sm-link">Click here</span>
          <span class="font-size-sm">if not redirected on merchant page.</span>
        </weex-text>

        <weex-text class="margin-top-10 text-align-center">
          <span @click="onDismissClicked" class="item-base-sm-link-without-color text-color-gray">Dismiss</span>
        </weex-text>

        <wxc-countdown
          v-if="!redirectionCountdownCompleted"
          v-show="false"
          tpl="{s}"
          :time="redirectionCountDowntime"
          @wxcOnComplete="onRedirectionCountdownCompleted"
          @countdownDetails="redirectionCountdownDetails"
        ></wxc-countdown>

      </div>
    </div>
  </div>
</template>

<script>
import WxcCountdown from "../../../weex-ui/packages/wxc-countdown/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

export default {
  components: { WxcOverlay, WxcCountdown },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    redirectionTimeInSeconds: {
      type: Number,
      default: 5
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    redirectionCountdownCompleted: false,
    redirectionCountdownRemainingSeconds: "",
    redirectionCountDowntime: ""
  }),

  methods: {
    initializeDialog() {
      this.redirectionCountdownCompleted = false;
      const redirectionCountDowntimeInSeconds =
        this.redirectionTimeInSeconds > 0 ? this.redirectionTimeInSeconds : 5;
      this.redirectionCountdownRemainingSeconds = redirectionCountDowntimeInSeconds;
      this.redirectionCountDowntime =
        new Date().getTime() + redirectionCountDowntimeInSeconds * 1000;
    },

    onDismissClicked() {
      this.$emit("onRedirectionCancelled");
    },

    redirectToPartnerPage() {
      this.$emit("onRedirect");
    },

    onRedirectionCountdownCompleted() {
      this.redirectionCountdownCompleted = true;
      this.redirectToPartnerPage();
    },

    redirectionCountdownDetails(countdownData) {
      this.redirectionCountdownRemainingSeconds = countdownData.second;
    }
  },

  computed: {
    redirectingOnPartnerPageMessage() {
      return "Please wait. You are being redirected to the partner's page in ";
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.redirecting-message-dialog-container {
  position: absolute;
  z-index: 10000;
}
</style>
